export default __webpack_public_path__ + "static/actions-ab5ef82510192429848f3e76fafb7f6a.png";